import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import 'translations/translations';

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
}));

type ValidatedInputProps = {
  inputName: string;
  required: boolean;
  autoFocus: boolean;
  label: string;
  type: string;
  margin?: 'normal' | 'none' | 'dense' | undefined;
  defaultValue?: string;
  handleChangeCallback: (name: string, value: string, error: boolean) => void;
};

const ValidatedTextInput: React.FC<ValidatedInputProps> = (props) => {
  const {
    inputName,
    type,
    required,
    label,
    autoFocus,
    margin,
    defaultValue,
    handleChangeCallback,
  } = props;
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState();
  const { t } = useTranslation(['translations']);
  const [value, setValue] = useState(defaultValue || '');

  const handleChange = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValue(value);

    const emailRE =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (required && !value) {
      setErrorMessage(t('validation.required'));
      handleChangeCallback(name, '', true);
      return;
    }

    if (type === 'email' && !!value && !emailRE.test(value)) {
      setErrorMessage(t('validation.email_invalid'));
      handleChangeCallback(name, '', true);
      return;
    }

    setErrorMessage(undefined);
    handleChangeCallback(name, value, false);
  };

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      <TextField
        type={type}
        variant="outlined"
        margin={margin ?? 'normal'}
        required={required}
        fullWidth
        id={inputName}
        label={label}
        name={inputName}
        autoComplete={type}
        autoFocus={autoFocus}
        onChange={handleChange}
        onBlur={handleChange}
        value={value}
      />

      <Typography className={classes.error}>
        {!!errorMessage && errorMessage}
      </Typography>
    </>
  );
};

export { ValidatedTextInput };
